export default "__VITE_ASSET__CDNRVist__"